import { CircularProgress } from '@mui/material'

export default function IsSearchingCircle() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 'calc(100vh - 200px)',
      }}
    >
      <CircularProgress sx={{ color: '#A4A4A4' }} size='4rem' />
    </div>
  )
}
